import { DisplayIaChatbotInterfaceState, initialDisplayIaChatbotInterfaceState } from '../state/display-ia-chatbot.state';
import { DisplayIaChatbotActions, EDisplayIaChatbotActions } from '../actions/display-ia-chatbot.actions';

export function displayIaChatbotReducer(state: DisplayIaChatbotInterfaceState = initialDisplayIaChatbotInterfaceState, action: DisplayIaChatbotActions): DisplayIaChatbotInterfaceState {
  switch (action.type) {
    case EDisplayIaChatbotActions.DisplayIaChatbot: {
      return { ...state, iaChatbotUrl: action.payload };
    }

    default:
      return state;
  }
};
